import { Container } from "@mui/material";
import { useLocation, useNavigate } from "react-router";

import GaiaLogo from "~/modules/app/components/GaiaLogo";

import LoginForm from "../components/LoginForm";

export default function Login() {
    const navigate = useNavigate();
    const location = useLocation();
    const from = location.state?.from?.pathname || "/";

    function handleLogin() {
        navigate(from, { replace: true });
    }

    return (
        <Container
            maxWidth="sm"
            sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
            }}
        >
            <GaiaLogo variant="horizontal" size={96} colored />
            <LoginForm sx={{ mt: 4, width: "100%" }} onLoggedIn={handleLogin} />
        </Container>
    );
}
